var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSanctionStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 14.9997V16.4997H0.333496V14.9997H9.3335ZM9.773 0.51416L15.6065 6.34766L14.546 7.40966L13.751 7.14416L11.8932 8.99966L16.136 13.2424L15.0755 14.3029L10.8335 10.0602L9.0305 11.8632L9.24275 12.7122L8.1815 13.7727L2.348 7.93916L3.40925 6.87866L4.25675 7.09016L8.97725 2.37041L8.7125 1.57541L9.773 0.51416Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSanctionStatus);
export default __webpack_public_path__ + "static/media/icon_sanction_status.80c732d7f35f7e7b9644be19cf2cc63d.svg";
export { ForwardRef as ReactComponent };